import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VTooltip from 'v-tooltip';
import App from './App.vue';
import store from './store';
import translations from './lang';
import { dummy } from '@/dummyData';
import { init } from '@/store/actions/lifecycle';
import { requestPause, requestPlay } from '@/store/actions/play';
import { toggleExtendedBlock } from '@/store/actions/visible-components';
import {
  PLAYER_INITIALIZE, PLAYER_PLAY, PLAYER_OPEN, PLAYER_PAUSE,
} from '@/utils/messages';

Vue.use(VTooltip);
Vue.use(VueI18n);

Vue.config.productionTip = false;

Array.from = undefined;

if (['production', 'qa', 'ew', 'embedded'].includes(process.env.VUE_APP_MODE)) {
  window.addEventListener('message', (message) => {
    if (message.data.type === PLAYER_INITIALIZE) {
      store.dispatch(init(message.data.data));
      // store.dispatch(toggleExtendedBlock(false));
    } else if (message.data.type === PLAYER_PLAY) {
      store.dispatch(requestPlay());
    } else if (message.data.type === PLAYER_OPEN) {
      // todo AUD-12 implement
    } else if (message.data.type === PLAYER_PAUSE) {
      store.dispatch(requestPause());
    }
  }, false);
} else {
  store.dispatch(init(dummy));
  store.dispatch(store.dispatch(toggleExtendedBlock(false)));
}

const i18n = new VueI18n({
  locale: 'de',
  fallbackLocale: 'en',
  messages: translations,
});

new Vue({
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
